import React, { useState, useEffect } from 'react';
import { AiFillEye } from 'react-icons/ai';
import { motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
import './Certificate.scss';

const Certificate = () => {
  const [certificates, setCertificates] = useState([]);
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });

  // Fetch certificates from Sanity
  useEffect(() => {
    const query = '*[_type == "certificates"]';
    client.fetch(query)
      .then((data) => setCertificates(data || []))
      .catch((err) => {
        console.error('Error fetching certificates:', err);
        setCertificates([]);
      });
  }, []);

  return (
    <div>
      <h2 className="head-text">
        Certi<span>ficates</span>
      </h2>

      {/* Certificates Grid */}
      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio"
      >
        {certificates.length > 0 ? (
          certificates.map((certificate, index) => (
            <div className="app__work-item app__flex" key={index}>
              <div className="app__work-img app__flex">
                {certificate.imgUrl ? (
                  <img src={urlFor(certificate.imgUrl)} alt={certificate.title || 'Certificate'} />
                ) : (
                  <div className="app__work-img-placeholder">No Image</div>
                )}

                <motion.div
                  whileHover={{ opacity: [0, 1] }}
                  transition={{ duration: 0.25, ease: 'easeInOut', staggerChildren: 0.5 }}
                  className="app__work-hover app__flex"
                >
                  {certificate.certificatelink && (
                    <a href={certificate.certificatelink} target="_blank" rel="noreferrer">
                      <motion.div
                        whileInView={{ scale: [0, 1] }}
                        whileHover={{ scale: [1, 0.9] }}
                        transition={{ duration: 0.25 }}
                        className="app__flex"
                      >
                        <AiFillEye />
                      </motion.div>
                    </a>
                  )}
                </motion.div>
              </div>

              <div className="app__work-content app__flex">
                <h4 className="bold-text">{certificate.title || 'No Title'}</h4>
                <p className="p-text" style={{ marginTop: 10 }}>
                  {certificate.description || 'No Description'}
                </p>
                <div className="app__work-tag app__flex">
                  <p className="p-text">{certificate.tags?.[0] || 'No Tag'}</p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No certificates found.</p>
        )}
      </motion.div>
    </div>
  );
};

export default AppWrap(
  MotionWrap(Certificate, 'app__certificates'),
  'certificate',
  'app__primarybg'
);
